import styled from '@emotion/styled';
import { Paragraph1, Select } from 'inpock-ui-react';
import { colors } from 'inpock-ui-react/dist/src/color';

export const StyledSelect = styled(Select)<{ active?: boolean }>`
  ${({ active }) =>
    active &&
    `
  .select-box {
    border: 1px solid ${colors.orange300};
  }

    select {
      background-color: #fef3e8;
    }
  `}
`;

export const Option = styled.button<{ last: boolean }>`
  width: 100%;
  outline: none;
  border: none;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 55px;
  margin-top: 2px;
  cursor: pointer;
  padding: 0 16px;
  border-bottom: ${(props) => (props.last ? 'none' : `1px solid ${colors.gray100}`)};
  transition:
    0.2s background-color,
    0.2s transform;

  :hover:not(:disabled) {
    background-color: ${colors.gray100};
  }

  :active {
    transform: scale(0.99); /* 클릭될 때 작아지도록 스케일을 조절합니다 */
  }

  :disabled {
    cursor: not-allowed; /* 디저블드 상태에서 포인터 이벤트 비활성화 */
    transform: none; /* 디저블드 상태에서 transform 효과 비활성화 */

    .inpock-typography.paragraph-1 {
      color: ${colors.gray300} !important;
      text-decoration: line-through;
    }
  }
`;

export const OptionText = styled(Paragraph1)`
  text-align: left;
  font-weight: 400 !important;
`;
